import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend,
    registerables 
  } from 'chart.js';
import { Chart } from 'react-chartjs-2';
import { faker } from "@faker-js/faker";
import { VisualizationMarkdown } from "../components/VisualizationMarkdown";

ChartJS.register(...registerables);
  
  export const options = {
    responsive: true,
    plugins: {
      legend: {
        position: 'top' as const,
      },
      title: {
        display: true,
        text: 'Chart.js Bar Chart',
      },
    },
  };
  
  const labels = ['January', 'February', 'March', 'April', 'May', 'June', 'July'];
  
  export const data = {
    labels,
    datasets: [
      {
        label: 'Dataset 1',
        data: labels.map(() => faker.number.int({ min: 0, max: 1000 })),
        backgroundColor: 'rgba(255, 99, 132, 0.5)',
      },
      {
        label: 'Dataset 2',
        data: labels.map(() => faker.number.int({ min: 0, max: 1000 })),
        backgroundColor: 'rgba(53, 162, 235, 0.5)',
      },
    ],
  };
    
const markdown = `
By default the two plugins for creating graphs are included:
- [Chart.js](https://www.chartjs.org/)
- [react-char-js-2](https://react-chartjs-2.js.org/)

Those allow you to make beautiful graphs.
`
export const GraphExamplePage = function() {
    return <>
        <h1>Graph Example</h1>
        <VisualizationMarkdown>{markdown}</VisualizationMarkdown>
        <Chart type='bar' options={options} data={data} />
    </>
}